import { FaFacebookF, FaTwitter, FaLinkedinIn, FaWhatsapp, FaEnvelope, FaLink } from 'react-icons/fa';
import { useState } from 'react';

const ShareSection = () => {
  const [copied, setCopied] = useState(false);
  const currentUrl = typeof window !== 'undefined' ? window.location.href : '';

  const shareOnFacebook = () => {
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${currentUrl}`, '_blank');
  };

  const shareOnTwitter = () => {
    window.open(`https://twitter.com/intent/tweet?url=${currentUrl}`, '_blank');
  };

  const shareOnLinkedIn = () => {
    window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${currentUrl}`, '_blank');
  };

  const shareOnWhatsApp = () => {
    window.open(`https://api.whatsapp.com/send?text=${encodeURIComponent(currentUrl)}`, '_blank');
  };

  const shareByEmail = () => {
    window.open(`mailto:?subject=Check out this article&body=${encodeURIComponent(currentUrl)}`, '_blank');
  };

  const copyLink = () => {
    navigator.clipboard.writeText(currentUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="mt-12 flex flex-col items-center gap-4 px-4">
      <span className="text-gray-700 font-semibold text-center">Share this article:</span>
      <div className="flex gap-4 overflow-x-auto pb-2">
        <button
          onClick={shareOnFacebook}
          className="bg-blue-600 text-white p-3 rounded-full hover:bg-blue-700 transition flex-shrink-0"
          aria-label="Share on Facebook"
        >
          <FaFacebookF />
        </button>
        <button
          onClick={shareOnTwitter}
          className="bg-sky-400 text-white p-3 rounded-full hover:bg-sky-500 transition flex-shrink-0"
          aria-label="Share on Twitter"
        >
          <FaTwitter />
        </button>
        <button
          onClick={shareOnLinkedIn}
          className="bg-blue-700 text-white p-3 rounded-full hover:bg-blue-800 transition flex-shrink-0"
          aria-label="Share on LinkedIn"
        >
          <FaLinkedinIn />
        </button>
        <button
          onClick={shareOnWhatsApp}
          className="bg-green-500 text-white p-3 rounded-full hover:bg-green-600 transition flex-shrink-0"
          aria-label="Share on WhatsApp"
        >
          <FaWhatsapp />
        </button>
        <button
          onClick={shareByEmail}
          className="bg-gray-700 text-white p-3 rounded-full hover:bg-gray-800 transition flex-shrink-0"
          aria-label="Share by Email"
        >
          <FaEnvelope />
        </button>
        <button
          onClick={copyLink}
          className="bg-gray-400 text-white p-3 rounded-full hover:bg-gray-500 transition flex-shrink-0"
          aria-label="Copy Link"
        >
          <FaLink />
        </button>
      </div>
      {copied && <span className="text-green-600 mt-2">Link copied to clipboard!</span>}
    </div>
  );
};

export default ShareSection;
